import styled from 'styled-components';

export const GameItemDelimiterBox = styled.div`
    margin-left: 2rem;
    background-size: cover;
    flex: 0 1 2.5rem;
    background-image: url(${props => '"' + props.theme.assets.images.vertical_line_glow_png.toString() + '"'});
    /* Inside .idleRecommendation-layout apply: width: 1.5rem; */
    .idleRecommendation-layout & {
        width: 1.5rem;
    }
`;